// Salesperson Details
export const SALESPERSON_DETAILS_REQUEST = 'SALESPERSON_DETAILS_REQUEST'
export const SALESPERSON_DETAILS_SUCCESS = 'SALESPERSON_DETAILS_SUCCESS'
export const SALESPERSON_DETAILS_FAIL = 'SALESPERSON_DETAILS_FAIL'
export const SALESPERSON_DETAILS_RESET = 'SALESPERSON_DETAILS_RESET'

// Update Salesperson
export const SALESPERSON_UPDATE_REQUEST = 'SALESPERSON_UPDATE_REQUEST'
export const SALESPERSON_UPDATE_SUCCESS = 'SALESPERSON_UPDATE_SUCCESS'
export const SALESPERSON_UPDATE_FAIL = 'SALESPERSON_UPDATE_FAIL'
export const SALESPERSON_UPDATE_RESET = 'SALESPERSON_UPDATE_RESET'
